import noop from '@qonto/ui-kit/helpers/noop';

export default noop;
